class MediaCarouselCard extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.product-card__carousel-track');
    this.slides = Array.from(this.querySelectorAll('.product-card__carousel-slide'));
    this.arrows = Array.from(this.querySelectorAll('.product-card__carousel-arrow'));
    this.currentIndex = 0;

    if (this.slides.length <= 1) return;

    this.onArrowClick = this.handleArrowClick.bind(this);
    this.onScroll = this.handleScroll.bind(this);
    this.onSwatchChange = this.handleSwatchChange.bind(this);

    this.arrows.forEach((arrow) => arrow.addEventListener('click', this.onArrowClick));
    this.track.addEventListener('scroll', this.onScroll, { passive: true });
    this.closest('product-card')?.addEventListener('change', this.onSwatchChange);

    this.updateUI(false);
  }

  disconnectedCallback() {
    this.arrows.forEach((arrow) => arrow.removeEventListener('click', this.onArrowClick));
    this.track?.removeEventListener('scroll', this.onScroll);
    this.closest('product-card')?.removeEventListener('change', this.onSwatchChange);
  }

  handleArrowClick(event) {
    event.preventDefault();
    event.stopPropagation();
    const direction = parseInt(event.currentTarget.dataset.direction, 10);
    this.goTo(this.currentIndex + direction);
  }

  handleScroll() {
    if (this.scrollTimeout) clearTimeout(this.scrollTimeout);
    this.scrollTimeout = setTimeout(() => {
      const slideWidth = this.track.clientWidth;
      if (!slideWidth) return;
      const index = Math.round(this.track.scrollLeft / slideWidth);
      this.currentIndex = Math.max(0, Math.min(index, this.slides.length - 1));
      this.updateUI(false);
    }, 80);
  }

  handleSwatchChange(event) {
    const input = event.target.closest('input[data-variant-media]');
    if (!input) return;

    try {
      const variantMedia = JSON.parse(input.dataset.variantMedia);
      const targetIndex = this.slides.findIndex(
        (slide) => slide.dataset.mediaId === String(variantMedia.id)
      );
      if (targetIndex !== -1) this.goTo(targetIndex);
    } catch (e) {}
  }

  goTo(index) {
    this.currentIndex = Math.max(0, Math.min(index, this.slides.length - 1));
    this.updateUI(true);
  }

  updateUI(moveTrack) {
    if (moveTrack) {
      const isTouch = window.matchMedia('(hover: none), (pointer: coarse)').matches;
      if (isTouch) {
        this.track.scrollTo({
          left: this.currentIndex * this.track.clientWidth,
          behavior: 'smooth',
        });
      } else {
        this.track.style.transform = `translate3d(-${this.currentIndex * 100}%, 0, 0)`;
      }
    }

    const prevArrow = this.querySelector('.product-card__carousel-arrow--prev');
    const nextArrow = this.querySelector('.product-card__carousel-arrow--next');
    if (prevArrow) prevArrow.classList.toggle('is-hidden', this.currentIndex === 0);
    if (nextArrow) nextArrow.classList.toggle('is-hidden', this.currentIndex === this.slides.length - 1);
  }
}

if (!customElements.get('media-carousel-card')) {
  customElements.define('media-carousel-card', MediaCarouselCard);
}